import React from "react";

import {
    Stack,
    Box,
    Text,
    Divider,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import GradientButton from "components/Buttons/GradientButton";

import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";


const ViewAgentService = ({
    isOpen,
    onClose,
    service,
    onEdit,
}) => {

    if (!service) {
        return null;
    }


    const status =
        service.is_active
            ? "Active"
            : "Inactive";


    return (

        <ReusableDrawer

            isOpen={
                isOpen
            }

            onClose={
                onClose
            }

            headerContent={
                <h2>
                    View Agent Service
                </h2>
            }

            bodyContent={

                <Stack
                    spacing={5}
                >

                    {/* SERVICE NAME */}

                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={1}
                        >
                            Service Name
                        </Text>

                        <Text
                            fontWeight="600"
                        >
                            {
                                service.name ||
                                "N/A"
                            }
                        </Text>

                    </Box>


                    <Divider />


                    {/* DESCRIPTION */}

                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={1}
                        >
                            Description
                        </Text>

                        <Text
                            whiteSpace="pre-wrap"
                        >
                            {
                                service.description ||
                                "N/A"
                            }
                        </Text>

                    </Box>


                    {/* STATUS */}

                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={2}
                        >
                            Status
                        </Text>

                        <StatusBadge

                            label={
                                status
                            }

                            variant={
                                getStatusVariant(
                                    status
                                )
                            }

                        />

                    </Box>


                    <Divider />


                    {/* CREATED */}

                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={1}
                        >
                            Date Created
                        </Text>

                        <Text
                            fontWeight="600"
                        >
                            {
                                service.created_at
                                    ? new Date(
                                        service.created_at
                                    ).toLocaleDateString()
                                    : "N/A"
                            }
                        </Text>

                    </Box>


                    {/* UPDATED */}

                    <Box>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            mb={1}
                        >
                            Last Updated
                        </Text>

                        <Text
                            fontWeight="600"
                        >
                            {
                                service.updated_at
                                    ? new Date(
                                        service.updated_at
                                    ).toLocaleDateString()
                                    : "Not updated"
                            }
                        </Text>

                    </Box>

                </Stack>

            }

            footerContent={

                <Stack
                    direction="row"
                    spacing={4}
                    justifyContent="flex-end"
                >

                    <GradientButton

                        width="100px"

                        height="40px"

                        onClick={
                            onClose
                        }

                    >
                        Close
                    </GradientButton>


                    <GradientButton

                        width="100px"

                        height="40px"

                        onClick={
                            onEdit
                        }

                    >
                        Edit
                    </GradientButton>

                </Stack>

            }

        />

    );
};


export default ViewAgentService;